import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Calculator } from "lucide-react";

interface ResultCardProps {
  time: string;
  number: string;
  special: string;
  third: string;
  country: "nicaragua" | "costa-rica";
  specialLabel?: string;
  isPlayed?: boolean;
}

const ResultCard = ({ time, number, special, third, country, specialLabel, isPlayed = false }: ResultCardProps) => {
  const countryColor = isPlayed 
    ? (country === "nicaragua" ? "bg-nicaragua" : "bg-costa-rica")
    : (country === "nicaragua" ? "bg-nicaragua-faded" : "bg-costa-rica-faded");
  
  // Determinar estilos del badge según el tipo
  const getBadgeStyles = () => {
    const specialUpper = special?.toUpperCase() || "";
    
    if (!isPlayed) {
      return "bg-muted text-muted-foreground text-xl";
    }
    if (specialUpper === "BOLITA BLANCA" || specialUpper === "BB") {
      return "bg-bolita-blanca text-bolita-blanca-foreground border border-bolita-blanca-border text-xl font-bold";
    }
    if (specialUpper === "REVENTADO" || specialUpper === "R") {
      return "bg-red-600 text-white border-0 text-2xl font-extrabold";
    }
    if (country === "nicaragua") {
      return "bg-multix-yellow text-multix-yellow-foreground text-xl font-bold";
    }
    return "bg-bolita-blanca text-bolita-blanca-foreground text-xl";
  };
  
  return (
    <Card className="overflow-hidden border-2 hover:shadow-lg transition-shadow">
      <div className={`${countryColor} px-4 py-4 text-center`}>
        <p className="text-2xl font-bold text-white">{time}</p>
        <p className="text-sm font-medium text-white/90">
          {country === "nicaragua" ? "Loto Diaria Nicaragua" : "Nuevos Tiempos Costa Rica"}
        </p>
      </div>
      
      <div className="p-6 space-y-4">
        {/* Primer número grande */}
        <div className="text-center">
          <p className={`result-number ${isPlayed ? (country === 'costa-rica' ? 'text-gray-700 dark:text-gray-300' : 'text-nicaragua') : 'text-muted-foreground'}`}>{number}</p>
        </div>

        {/* Dato especial (MultiX o Bolita) */}
        <div className="text-center border-t pt-4 flex flex-col items-center">
          {country === "nicaragua" && (
            <p className="text-base font-semibold text-muted-foreground mb-2">MultiX</p>
          )}
          <div className="flex items-center justify-center">
            <Badge className={`pointer-events-none rounded-full w-16 h-16 flex items-center justify-center p-0 ${getBadgeStyles()}`}>
              <span className="text-center leading-none">
                {special === "Reventado" ? "R" : special === "Bolita Blanca" ? "BB" : special}
              </span>
            </Badge>
          </div>
        </div>

        {/* Tercer número */}
        <div className="text-center border-t pt-4">
          <p className="text-base font-semibold text-muted-foreground mb-1">
            {country === "nicaragua" ? "Más Uno" : "Mega Reventados"}
          </p>
          <p className={`text-4xl font-bold ${isPlayed ? (country === 'costa-rica' ? 'text-red-600' : 'text-nicaragua') : 'text-muted-foreground'}`}>{third}</p>
        </div>

      </div>
    </Card>
  );
};

export default ResultCard;
